module.exports = __webpack_public_path__ + "static/media/button-more.62d0e592.svg";